import React from 'react'

import { IMG } from '../../../../themes'
import { StylesRepeatOptions } from './styles'

const RepeatOptions = (props) => {
  const { list, selectedIndex, onSelected, isMonthly, colorTheme } = props

  return list.map(({ key, value }, index) => {
    const isSelected = index === selectedIndex

    return (
      <StylesRepeatOptions
        className='default-padding'
        key={key}
        onClick={() => onSelected(key, index)}
        isMonthly={isMonthly}
        colorTheme={colorTheme}
      >
        { isSelected && <img className='check-icon' src={IMG['check.svg']} alt='check' /> }
        <label className={isSelected ? 'option-active-text' : 'option-text'}>{value}</label>
      </StylesRepeatOptions>
    )
  })
}

export default RepeatOptions
